var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangeBg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#506D85",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#506D85",
    strokeWidth: 0.5,
    d: "M2 19.87c0 1.163.947 2.106 2.106 2.106H19.87a2.109 2.109 0 0 0 2.107-2.107V4.106A2.109 2.109 0 0 0 19.869 2H4.106A2.109 2.109 0 0 0 2 4.106V19.87zm17.87 1.106H4.105A1.11 1.11 0 0 1 3 19.869v-2.632l3.788-3.788 3.236 3.237c.196.196.51.196.707 0l5.845-5.845 4.4 4.4v4.628a1.11 1.11 0 0 1-1.107 1.107zM4.105 3H19.87a1.11 1.11 0 0 1 1.107 1.106v9.718l-4.05-4.044a.498.498 0 0 0-.706 0l-5.844 5.844-3.237-3.236a.498.498 0 0 0-.706 0L3 15.82V4.106A1.11 1.11 0 0 1 4.106 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.192 10.004a2.546 2.546 0 0 0 2.543-2.543c0-1.4-1.143-2.543-2.543-2.543a2.548 2.548 0 0 0-2.543 2.543c0 1.4 1.139 2.543 2.543 2.543zm0-4.086c.853 0 1.543.694 1.543 1.543 0 .85-.694 1.543-1.543 1.543a1.547 1.547 0 0 1-1.543-1.543c0-.849.69-1.543 1.543-1.543z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeBg);
export default __webpack_public_path__ + "static/media/change-bg.af74e88332c9feb71ee5b774dca62ab8.svg";
export { ForwardRef as ReactComponent };